import React, { useEffect, useRef, useState } from "react";
import { all_routes } from "../../router/all_routes";
import PredefinedDateRanges from "../../../core/common/datePicker";
import CommonSelect from "../../../core/common/commonSelect";
import {
  driverFilter2,
  driverName,
  GPSDevice,
  status,
  vehicleModel,
  VehicleNumber,
} from "../../../core/common/selectoption/selectoption";
import { TableData } from "../../../core/data/interface";
import Table from "../../../core/common/dataTable/index";
import TooltipOption from "../../../core/common/tooltipOption";
import TransportModal from "./transportModal";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { transportVehicles } from "../../../core/data/json/transport_vehicle";
import { Link, useNavigate } from "react-router-dom";
import { gql, useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { Modal } from "react-bootstrap";
import {
  GoogleMap,
  LoadScript,
  DirectionsService,
  DirectionsRenderer,
  Marker,
  InfoWindow,
  Polyline,
  useJsApiLoader,
} from '@react-google-maps/api';

const GET_VEHICLES = gql`
  query GetAllVehicleDetails($clientLoginId: Int!) {
    getAllVehicleDetails(
      clientLoginId: $clientLoginId
    ) {
      vehicleType
      vehicleNumber
      deviceDetail {
        uniqueDeviceId
      }
    }
  }
`;


const GENERATE_AUTH_TOKEN = gql`
    query generateAuthTokenAPI($username: String!, $password: String!) {
        generateAuthTokenAPI(username: $username, password: $password) {
            token
        }
    }
`;

const GET_LATEST_LOCATION = gql`
    query getLatestLocation($uniqueId: String!) {
        getDeviceLatestLocation(deviceId: $uniqueId) {
            timestamp
            latitude
            longitude
            haltStatus
            idlingStatus
            isOverspeed
            speed
            extBatVol
            isPrimaryBattery
            isNoGps
            address
        }
    }
`;



interface VehicleDetail {
  vehicleType: string;
  vehicleNumber: string;
  deviceDetail: {
    uniqueDeviceId: string;
  };
}

interface GetAllVehiclesData {
  getAllVehicleDetails: VehicleDetail[];
}

const TransportVehicle = () => {
  const initialCenter = { lat: 7.365302, lng: 12.343439 };
  const [center, setCenter] = useState(initialCenter);
  const [markerPosition, setMarkerPosition] = useState<any>();
  const mapContainerStyle = {
    width: '100%',
    height: '400px'
  };
  const [mapKey, setMapKey] = useState(0);
  // Hook pour charger le script Google Maps
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyDp2ZqWgffPdF4qtCCe1NUsCEd8YWZbmTU",
  });


  const carIconUrl = "../../assets/img/bus.png";


  const markerStyle = markerPosition
    ? {
      url: carIconUrl, // Assurez-vous que l'URL est correctement définie ici
      scaledSize: new window.google.maps.Size(50, 50), // Taille de l'icône
      rotation: 45, // Exemple de rotation
    }
    : null;






  const routes = all_routes;
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  // const data = transportVehicles;
  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
  };

  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [address, setAddress] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showDangerToast, setShowDangerToast] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);

  const handleSuccessToastClose = () => {
    setShowSuccessToast(false);
  };

  const handleDangerToastClose = () => {
    setShowDangerToast(false);
  };

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const handleClose2 = () => setShowModal2(false);
  const handleShow2 = () => setShowModal2(true);

  const [vehicles, setVehicles] = useState<any>([])
  const [vehicle, setVehicle] = useState<any>()

  // Utilisation de la requête avec des variables
  const { data, loading, error } = useQuery<any>(GET_VEHICLES, {
    variables: { clientLoginId: 1316 },
  });

  console.log("Loading:", loading);
  console.log("Error:", error);
  console.log("Data:", data);


  const [authToken, setAuthToken] = useState(null);

  // Première requête pour générer le token
  const { data: authData, loading: authLoading, error: authError } = useQuery(GENERATE_AUTH_TOKEN, {
    variables: {
      username: "eneotrack",
      password: "Afr!Tr@ck"
    },
    onCompleted: (data) => {
      setAuthToken(data.generateAuthTokenAPI.token);
    }
  });


  // Utiliser useLazyQuery pour obtenir la dernière localisation
  const [getLocation, { data: locationData, loading: locationLoading, error: locationError }] = useLazyQuery(GET_LATEST_LOCATION);

  const [mapInstance, setMapInstance] = useState<google.maps.Map | null>(null);








  useEffect(() => {
    if (data) {
      setVehicles(data?.getAllVehicleDetails)
    }
  }, [])


  useEffect(() => {
    if (isLoaded && mapInstance) {
      google.maps.event.trigger(mapInstance, "resize");
      if (markerPosition) {
        mapInstance.setCenter(markerPosition);
      }
    }
  }, [isLoaded, markerPosition]);
  const handleModal = async (record: any) => {
    setVehicle(record);

    if (authToken) {
      try {
        const response = await getLocation({
          variables: {
            uniqueId: record?.deviceDetail?.uniqueDeviceId,
          },
          context: {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          },
        });

        const data = response.data.getDeviceLatestLocation;
        if (data) {
          const newLat = parseFloat(data.latitude);
          const newLng = parseFloat(data.longitude);

          console.log('New Position:', { lat: newLat, lng: newLng });

          if (!isNaN(newLat) && !isNaN(newLng)) {


            // Ouvrir le modal après avoir mis à jour la position du marqueur
            handleShow();

            // Redessiner la carte après avoir ouvert le modal
            const timeoutId = setTimeout(() => {
              setMarkerPosition({ lat: newLat, lng: newLng });
              setCenter({ lat: newLat, lng: newLng });
              setAddress(data?.address);
            }, 1000); // 1 second delay

            return () => clearTimeout(timeoutId);

          } else {
            console.error('Invalid coordinates:', data.latitude, data.longitude);
          }
        } else {
          console.error('No data returned from location query');
        }
      } catch (error) {
        console.error('Error fetching location:', error);
      }
    }
  };


  const navigation = useNavigate()

  const navigeDetails = (id: any) => {
    navigation(`/management/transport-vehicle/${id}`)
  }




  const columns = [
    {
      title: "unique Device Id",

      render: (record: any) => (
        <Link to="#" className="link-primary">
          {record?.deviceDetail?.uniqueDeviceId}
        </Link>
      ),
    },
    {
      title: "Vehicle Number",
      render: (record: any) => (
        <span >
          {record?.vehicleNumber}
        </span>
      ),
    },
    {
      title: "Vehicle Type",
      render: (record: any) => (
        <span >
          {record?.vehicleType}
        </span>
      ),
    },
    {
      title: " ",
      render: (record: any) => (
        <a
          className="btn btn-light live track"
          onClick={() => handleModal(record)}
        >
          Last Position
        </a>
      ),
    },
    {
      title: " ",
      render: (record: any) => (
        <a
          className="btn btn-primary live track"
          onClick={() => navigeDetails(record?.deviceDetail?.uniqueDeviceId)}
        >
          Live Track
          <i className="mx-2 ti ti-bus"></i>
        </a>
      ),
    },
    /* {
      title: "Vehicle Model",
      dataIndex: "vehicleModel",
      sorter: (a: TableData, b: TableData) =>
        a.vehicleModel.length - b.vehicleModel.length,
    },
    {
      title: "Made of Year",
      dataIndex: "madeofYear",
      sorter: (a: TableData, b: TableData) =>
        a.madeofYear.length - b.madeofYear.length,
    },
    {
      title: "Registration No",
      dataIndex: "registrationNo",
      sorter: (a: TableData, b: TableData) =>
        a.registrationNo.length - b.registrationNo.length,
    },
    {
      title: "Chassis No",
      dataIndex: "chassisNo",
      render: (text: string) => (
        <span className="badge bg-soft-light">{text}</span>
      ),
      sorter: (a: TableData, b: TableData) =>
        a.chassisNo.length - b.chassisNo.length,
    },
    {
      title: "GPS Device ID",
      dataIndex: "gps",
      sorter: (a: TableData, b: TableData) => a.gps.length - b.gps.length,
    },
    {
      title: " ",
      dataIndex: "phone",
      render: () => (
        <Link
          to="#"
          className="btn btn-light live track"
          data-bs-toggle="modal"
          data-bs-target="#live_track"
        >
          Live Track
        </Link>
      ),
    },
    {
      title: "Driver",
      dataIndex: "name",
      render: (text: string, record: any) => (
        <div className="d-flex align-items-center">
          <Link to="#" className="avatar avatar-md">
            <ImageWithBasePath
              src={record.img}
              className="img-fluid rounded-circle"
              alt="img"
            />
          </Link>
          <div className="ms-2">
            <p className="text-dark mb-0">
              <Link to="#">{text}</Link>
            </p>
            <span className="fs-12">{record.phone}</span>
          </div>
        </div>
      ),
      sorter: (a: TableData, b: TableData) => a.name.length - b.name.length,
    },
  
    {
      title: "Status",
      dataIndex: "status",
      render: (text: string) => (
        <>
          {text === "Active" ? (
            <span className="badge badge-soft-success d-inline-flex align-items-center">
              <i className="ti ti-circle-filled fs-5 me-1"></i>
              {text}
            </span>
          ) : (
            <span className="badge badge-soft-danger d-inline-flex align-items-center">
              <i className="ti ti-circle-filled fs-5 me-1"></i>
              {text}
            </span>
          )}
        </>
      ),
      sorter: (a: TableData, b: TableData) => a.status.length - b.status.length,
    },
  */
    {
      title: "Action",
      dataIndex: "action",
      render: () => (
        <>
          <div className="d-flex align-items-center">
            <div className="dropdown">
              <Link
                to="#"
                className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="ti ti-dots-vertical fs-14" />
              </Link>
              <ul className="dropdown-menu dropdown-menu-right p-3">
                <li>
                  <Link
                    className="dropdown-item rounded-1"
                    to="#"
                    data-bs-toggle="modal"
                    data-bs-target="#edit_vehicle"
                  >
                    <i className="ti ti-edit-circle me-2" />
                    Edit
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item rounded-1"
                    to="#"
                    data-bs-toggle="modal"
                    data-bs-target="#delete-modal"
                  >
                    <i className="ti ti-trash-x me-2" />
                    Delete
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </>
      ),
    },
  ];
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Transport</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="#">Management</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Transport
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <TooltipOption />
              <div className="mb-2">
                <Link
                  to="#"
                  className="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#add_vehicle"
                >
                  <i className="ti ti-square-rounded-plus me-2" />
                  Add Vehicle
                </Link>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          {/* Students List */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Transport</h4>
              <div className="d-flex align-items-center flex-wrap">
                <div className="input-icon-start mb-3 me-2 position-relative">
                  <PredefinedDateRanges />
                </div>
                <div className="dropdown mb-3 me-2">
                  <Link
                    to="#"
                    className="btn btn-outline-light bg-white dropdown-toggle"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="outside"
                  >
                    <i className="ti ti-filter me-2" />
                    Filter
                  </Link>
                  <div
                    className="dropdown-menu drop-width"
                    ref={dropdownMenuRef}
                  >
                    <form>
                      <div className="d-flex align-items-center border-bottom p-3">
                        <h4>Filter</h4>
                      </div>
                      <div className="p-3 border-bottom">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Vehicle Number
                              </label>
                              <CommonSelect
                                className="select"
                                options={VehicleNumber}
                                defaultValue={undefined}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Model</label>
                              <CommonSelect
                                className="select"
                                options={vehicleModel}
                                defaultValue={vehicleModel[0]}
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="mb-3">
                              <label className="form-label">Name</label>
                              <CommonSelect
                                className="select"
                                options={driverName}
                                defaultValue={driverName[0]}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">GPS Device</label>
                              <CommonSelect
                                className="select"
                                options={GPSDevice}
                                defaultValue={undefined}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-0">
                              <label className="form-label">Driver</label>
                              <CommonSelect
                                className="select"
                                options={driverName}
                                defaultValue={undefined}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Status</label>
                              <CommonSelect
                                className="select"
                                options={status}
                                defaultValue={status[0]}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-0">
                              <label className="form-label">More Filter</label>
                              <CommonSelect
                                className="select"
                                options={driverFilter2}
                                defaultValue={driverFilter2[0]}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="p-3 d-flex align-items-center justify-content-end">
                        <Link to="#" className="btn btn-light me-3">
                          Reset
                        </Link>
                        <Link
                          to="#"
                          className="btn btn-primary"
                          onClick={handleApplyClick}
                        >
                          Apply
                        </Link>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="dropdown mb-3">
                  <Link
                    to="#"
                    className="btn btn-outline-light bg-white dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-sort-ascending-2 me-2" />
                    Sort by A-Z{" "}
                  </Link>
                  <ul className="dropdown-menu p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Descending
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Recently Viewed
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Recently Added
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0 py-3">
              {/* Student List  */}
              <Table dataSource={data?.getAllVehicleDetails} columns={columns} Selection={true} />
              {/* /Student List */}
            </div>
          </div>
          {/* /Students List */}
        </div>
      </div>
      {/* /Page Wrapper */}
      <TransportModal />



      <Modal show={showModal} onHide={handleClose} size={'xl'}>
        <Modal.Header >
          <Modal.Title>Live Tracking Vehicle <span className="badge badge-soft-primary ms-2">
            Imei : {vehicle?.deviceDetail?.uniqueDeviceId}
          </span></Modal.Title>
          <button
            type="button"
            className="btn-close custom-btn-close"
            onClick={handleClose}

          >
            <i className="ti ti-x" />
          </button>
        </Modal.Header>
        <Modal.Body>
          <ul className="book-taker-info live-track-info justify-content-between">
            <li>
              <span>Vehicle No</span>
              <h6> {vehicle?.vehicleNumber}</h6>
            </li>
            <li>
              <span>Vehicle Type</span>
              <h6> {vehicle?.vehicleType}</h6>
            </li>
            <li>
              <span>Driver</span>
              <h6>----</h6>
            </li>
            <li>
              <span>Driver Contact No</span>
              <h6>----</h6>
            </li>
          </ul>
          <div className="live-track-map w-100">

            {isLoaded ? (
              <GoogleMap
                mapContainerStyle={mapContainerStyle}
                center={center}
                zoom={20} // Niveau de zoom initial
                onLoad={(map) => setMapInstance(map)}
                options={{ zoomControl: true }} // Activer les contrôles de zoom
              >
                <Marker
                  key={`${markerPosition?.lat}-${markerPosition?.lng}`}
                  position={markerPosition}
                  //   label={{ text: `v`, color: "white", fontWeight: "bold" }}
                  icon={markerStyle || undefined}

                />


              </GoogleMap>
            ) : (
              <div>Loading map...</div>
            )}

            <span className="badge badge-soft-primary ms-2">{address}</span>
          </div>
        </Modal.Body>
        <Modal.Footer >

          <Link
            to="#"
            className="btn btn-light me-2"
            onClick={handleClose}
          >
            Cancel
          </Link>
          <Link
            to="#"
            onClick={handleClose}
            className="btn btn-primary"
          >
            Reset to Live Location
          </Link>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TransportVehicle;
